import parse from 'vue-notification/src/parser'

export default {
    namespaced: true,
    state: {
        brands: []
    },
    getters: {
        brands(state) {
            return state.brands
        },
        brandName: state => id => {
            const brand = state.brands.find(
                brandItem => brandItem.BrandID === parseInt(id, 10)
            )

            return brand ? brand.BrandName : 'brand'
        },
        //values for supplier products page filter, default all
        brandsValuesArr(state) {
            return state.brands.map(brand => brand.BrandID)
        }
    },
    mutations: {
        SET_BRANDS(state, brands) {
            state.brands = brands
        }
    },
    actions: {
        async getBrands({ commit }, data) {
            const brands = await this.$axios
                .get('/public/dict/brands', {
                    params: data
                })
                .then(res => {
                    return res.data
                })

            commit('SET_BRANDS', brands)
        }
    }
}
